import { render } from "./ComponenteInputDemanda.vue?vue&type=template&id=1ba340a2"
import script from "./ComponenteInputDemanda.vue?vue&type=script&lang=js"
export * from "./ComponenteInputDemanda.vue?vue&type=script&lang=js"

import "./ComponenteInputDemanda.vue?vue&type=style&index=0&id=1ba340a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__